<template>
  <aside
    class="parametres-container"
    v-if="isAdmin"
    :class="{ disabled: !paramBtnActive, disabled_after_offer: !isEditable }"
  >
    <div class="title-container">
      <h2>{{ translate("admin") }}</h2>
    </div>
    <transition-group name="list" tag="div" class="elements-container">
      <div
        v-for="(param, param_id) in getAdminParameters"
        v-if="param.active"
        class="element"
        :key="param.title"
      >
        <h3 class="title" v-html="translate(param_id)" />

        <div
          v-for="(option, option_id) in param.options"
          class="option-container"
          :class="{
            radio_type: option.type === 'radio',
            select_type: option.type === 'select',
            disabled: !paramBtnActive,
          }"
        >
          <div
            v-if="option.type === 'radio'"
            v-for="(element, element_id) in option.elements"
            class="radio-btn"
            :class="{ checked: element.active, disabled: !paramBtnActive }"
          >
            <input
              type="radio"
              :class="{ disabled_after_offer: !isEditable }"
              :id="param_id + '_' + option_id + '_' + element_id"
              :value="element.value"
              :checked="element.active"
              @change="
                selectElementOfOptionInParam(param_id, option_id, element_id),
                  enableCalcButton()
              "
              hidden
            />
            <label
              :for="param_id + '_' + option_id + '_' + element_id"
              v-html="
                translate(
                  element.displayValue ? element.displayValue : element.value,
                  false
                )
              "
              :class="{ disabled: !paramBtnActive }"
            />
          </div>

          <div
            v-if="option.type === 'select'"
            class="value_with_select-container"
          >
            <input
              v-if="typeof param.value !== 'undefined'"
              type="text"
              :class="{ disabled_after_offer: !isEditable }"
              :step="getStep(option)"
              :id="param_id + '_' + 'value'"
              :value="translate(calcUnit(param, option), false)"
              @input="setFilter(param_id, option, $event.target.value, $event)"
            />
            <span
              v-if="typeof option.value !== 'undefined'"
              class="option-title"
              v-html="
                translate(
                  option.displayValue ? option.displayValue : option.value
                )
              "
            />
            <div class="custom-select">
              <div
                class="selected_item"
                v-for="(element, element_id) in option.elements"
                v-if="element.active"
                :class="{
                  with_title: typeof option.value !== 'undefined',
                  own_item_style: param_id == 'ex',
                }"
              >
                <span
                  class="value"
                  v-html="
                    translate(
                      element.displayValue
                        ? element.displayValue
                        : element.value,
                      false
                    )
                  "
                />
                <span class="icon-bottom_arrow" />
              </div>
              <div class="items-container">
                <div
                  class="item"
                  v-for="(element, element_id) in option.elements"
                  v-if="!element.hidden"
                  :id="param_id + '_' + option_id + '_' + element_id"
                  @click="
                    selectElementOfOptionInParam(
                      param_id,
                      option_id,
                      element_id
                    ),
                      enableCalcButton()
                  "
                  v-html="
                    translate(
                      element.displayValue
                        ? element.displayValue
                        : element.value,
                      false
                    )
                  "
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition-group>
    <adjust-result-btn-admin />
  </aside>
</template>

<script>
import AdjustResultBtnAdmin from "@/components/configuration_steps/fourthStep/AdjustResultBtnAdmin";
import debounce from "lodash.debounce";

export default {
  name: "AdminSelection",
  data() {
    return {
      paramBtnActive: true,
      filterChanges: [],
    };
  },
  components: {
    AdjustResultBtnAdmin,
  },
  methods: {
    translate(code, displayErrors = true) {
      let arg = {
        type: "translate",
        code: code,
        displayErrors: displayErrors,
        out: "",
      };
      this.$store.commit(arg);
      return arg.out;
    },

    enableCalcButton() {
      this.$store.commit({
        type: "toggleAdjustResultBtnAdmin",
        disabled: false,
      });
    },

    setFilter(element, value, type, hook) {
      this.filterChanges.push({
        element,
        value,
        type,
        hook,
      });
      this.filterValues();
    },

    filterValues: debounce(function () {
      for (let change in this.filterChanges) {
        if (isNaN(change)) break;
        let a = this.filterChanges[change];
        this.changeParamValue(a.element, a.value, a.type, a.hook);
      }
      this.filterChanges = [];
      this.enableCalcButton();
    }, 700),

    selectElementOfOptionInParam(param_id, option_id, element_id) {
      if (this.$store.state.adminParameters.hasOwnProperty(param_id)) {
        this.$store.commit({
          type: "selectElementOfOptionInParamAdmin",
          param_id: param_id,
          option_id: option_id,
          element_id: element_id,
        });
      }
    },
    toggleExpandOfCustomSelect(e) {
      let target = e.target;
      document.querySelectorAll(".custom-select").forEach((select) => {
        select.classList.remove("expanded");
      });

      while (target instanceof Element) {
        if (target.classList.contains("selected_item")) {
          target.parentElement.classList.toggle("expanded");
          return;
        } else if (
          target.classList.contains("value") ||
          target.classList.contains("icon-bottom_arrow")
        ) {
          target.parentElement.parentElement.classList.toggle("expanded");
          return;
        } else if (target.classList.contains("items-container")) {
          target.parentElement.classList.remove("expanded");
          return;
        } else if (target.classList.contains("item")) {
          target.parentElement.parentElement.classList.remove("expanded");
          return;
        } else {
          return;
        }
      }
    },
  },
  computed: {
    isEditable() {
      return this.$store.getters.isOfferEditable;
    },
    isAdmin() {
      return this.$store.getters.getUserRole == "admin";
    },
    getAdminParameters() {
      return this.$store.state.adminParameters;
    },
  },
  mounted() {
    document.addEventListener("click", this.toggleExpandOfCustomSelect);

    this.$root.$on("disabledParamAside", () => {
      this.paramBtnActive = false;
    });

    this.$root.$on("enabledParamAside", () => {
      this.paramBtnActive = true;
    });
  },
  beforeDestroy() {
    document.removeEventListener("click", this.toggleExpandOfCustomSelect);
  },
};
</script>
